import { useEffect, MutableRefObject, useState } from 'react';
import {
  useOutsideFrameMessenger,
  useInsideFrameMessenger,
  simpleStateSetHandler,
} from './messengerHooks';

interface SyncHeightState {
  height?: number;
}
const heightMessageKey = 'syncHeight' as const;

const syncIFrameHeightHandlers = {
  [heightMessageKey]: simpleStateSetHandler,
};

export const useSyncIFrameHeight = () => {
  const { state, registerIFrame } = useOutsideFrameMessenger<SyncHeightState>({
    key: 'syncHeight',
    messageHandlers: syncIFrameHeightHandlers,
  });

  return { registerIFrame, height: state?.height };
};

export const useSyncIFrameHeightInsideFrame = (
  ref: MutableRefObject<HTMLElement | null>
) => {
  const [isReady, setIsReady] = useState(false);
  const { sendMessage } = useInsideFrameMessenger<SyncHeightState>({
    allowExternal: true,
    key: 'syncHeight',
    messageHandlers: {
      ['ready']: () => {
        setIsReady(true);
        sendMessage(
          heightMessageKey,
          {
            height: ref.current?.clientHeight,
          },
          true
        );
      },
    },
  });

  useEffect(() => {
    const observer = new ResizeObserver((entries) => {
      const entry = entries[0];

      if (entry && sendMessage) {
        const height = entry.contentRect.height;
        sendMessage(
          heightMessageKey,
          {
            height,
          },
          true
        );
      }
    });

    if (ref?.current) {
      observer.observe(ref.current);
    }

    return () => {
      observer.disconnect();
    };
  }, [ref, sendMessage]);

  return { isReady };
};
